import { PurchaseInfo } from "../components/mypage/PurchaseHistory";
import { RegionType } from "../module/map/analysis";
import { RegionAnalysisQueryParams, RegionAnalysisReqBody, AccessibilityReqBody, AnalysisGateway, IsochroneReqBody, RouteReqBody, SlopeReqBody } from "./gateways/AnalysisGateway";
import { ResponseType } from "./gateways/Gateway";
import { UserIdReqBody, DecodeParams } from "./gateways/UserGateway";
import { GeojsonGateway } from "./gateways/GeojsonGateway";
import { MapGateway, MapInfoReqBody, ListSearchReqBody, SaveMapReqBody, KMLQueryParams, MapQueryParams, FeatureListReqBody } from "./gateways/MapGateway";
import { PlaceAllQueryParams, PlaceGateway, PlaceInfoQueryParams, PlaceInfoReqBody, PlaceQueryParams, AllPlaceInfoReqBody } from "./gateways/PlaceGateway";
import RequestGateway, { AddressValidateReqBody, GeocodingQueryParams, MultiFullGeocodingReqBody, RevGeocodingQueryParams } from "./gateways/RequestGateway";
import { LoginQueryParams, SessionGateway } from "./gateways/SessionGateway ";
import { PasswordQueryParams, PasswordResetParams, UpgradeQueryParams, UserActivityQueryParams, UserGateway, UserInfoReqBody, UserInfoNotLogInReqParam } from "./gateways/UserGateway";
import { MailingGateway, FindPasswordParams, FAQMailQueryParams } from "./gateways/MailingGateway";
import { PlaceImageGateway, PlaceImageQueryParams } from "./gateways/PlaceImageGateway";
import { FAQGateway, FAQListQueryParams, FAQType, FAQViewID } from "./gateways/FAQGateway";
import { StoryGateway, StoryListReqBody, StoryQueryParams, StoryReportReqBody } from "./gateways/StoryGateway";
import { AIGateway, SummaryReqBody, SSEStreamCallback } from "./gateways/AIGateway";

export default class DataProvider {
    private static _analysis: AnalysisGateway = new AnalysisGateway();
    private static _geojson: GeojsonGateway = new GeojsonGateway();
    private static _map: MapGateway = new MapGateway();
    private static _place: PlaceGateway = new PlaceGateway();
    private static _story: StoryGateway = new StoryGateway();
    private static _user: UserGateway = new UserGateway();
    private static _session: SessionGateway = new SessionGateway();
    private static _request: RequestGateway = new RequestGateway();
    private static _mail: MailingGateway = new MailingGateway();
    private static _image: PlaceImageGateway = new PlaceImageGateway();
    private static _faq: FAQGateway = new FAQGateway();
    private static _ai: AIGateway = new AIGateway();

    // Session
    public static async Login(query: LoginQueryParams): Promise<ResponseType> {
        return await this._session.reqLogin(query);
    }
    public static async Logout(): Promise<ResponseType> {
        return await this._session.reqLogOut();
    }

    // User
    //GET
    public static async GetPurhcaseList(): Promise<ResponseType> {
        return await this._user.reqPurchaseList();
    }

    public static async GetDecode(query: DecodeParams): Promise<ResponseType> {
        return await this._user.reqDecode(query);
    }

    //POST
    public static async GetUserInfo(): Promise<ResponseType> {
        return await this._user.reqUserData();
    }

    public static async GetUserNotLogInInfo(query: UserInfoNotLogInReqParam): Promise<ResponseType> {
        return await this._user.reqUserDataNotLogIn(query);
    }

    public static async GetUserId(body: UserIdReqBody): Promise<ResponseType> {
        return await this._user.reqUserId(body);
    }

    public static async GetUserMapList(body: ListSearchReqBody): Promise<ResponseType> {
        return await this._user.reqUserMapList(body);
    }

    public static async UpdateUserInfo(data: UserInfoReqBody): Promise<ResponseType> {
        return await this._user.reqUpdateUserInfo(data);
    }

    public static async UpdatePassword(query: PasswordQueryParams): Promise<ResponseType> {
        return await this._user.reqUpdatePassword(query);
    }

    public static async ResetPassword(query: PasswordResetParams): Promise<ResponseType> {
        return await this._user.reqResetPassword(query);
    }

    public static async DeleteUser(query: PasswordQueryParams): Promise<ResponseType> {
        return await this._user.reqDeleteUser(query);
    }
    public static async UpgradeUser(query: UpgradeQueryParams): Promise<ResponseType> {
        return await this._user.reqUpgrade(query);
    }
    public static async UpdateRefund(query: PurchaseInfo): Promise<ResponseType> {
        return await this._user.reqRefund(query);
    }
    public static async Unsubscribe(): Promise<ResponseType> {
        return await this._user.reqUnsubscribe();
    }
    public static async Resubscribe(): Promise<ResponseType> {
        return await this._user.reqResubscribe();
    }
    public static async UpdateUserActivity(query: UserActivityQueryParams): Promise<ResponseType> {
        return await this._user.reqUpdateUserActivity(query);
    }

    // Map
    public static async SaveMap(body: SaveMapReqBody): Promise<ResponseType> {
        return await this._map.reqMapSave(body);
    }

    public static async GetMapCountData(): Promise<ResponseType> {
        return await this._map.reqMapCount();
    }

    // !@#!-OA1-MS3-USE1>METHOD1-GM1. MapInfo 백엔드 API 호출 - 지도 정보 및 오버랩 지도 정보 조회
    public static async GetMapInfo(query: MapQueryParams, body?: MapInfoReqBody): Promise<ResponseType> {
        return await this._map.reqMapInfoData(query, body);
    }

    public static async GetMetadata(query: MapQueryParams, body?: MapInfoReqBody): Promise<ResponseType> {
        return await this._map.reqMapMetadata(query, body);
    }

    public static async GetRecommendMapList(): Promise<ResponseType> {
        return await this._map.reqRecommendMapList();
    }

    public static async GetMapList(body: ListSearchReqBody): Promise<ResponseType> {
        return await this._map.reqMapList(body);
    }

    public static async GetKML(query: KMLQueryParams): Promise<ResponseType> {
        return await this._map.reqKML(query);
    }

    public static async UpdateMapViewCnt(query: MapQueryParams): Promise<ResponseType> {
        return await this._map.reqUpdateViewCnt(query);
    }

    public static async DeleteMap(query: MapQueryParams): Promise<ResponseType> {
        return await this._map.reqDeleteMap(query);
    }

    public static async UpdateMapInfo(query: MapQueryParams, body: SaveMapReqBody): Promise<ResponseType> {
        return await this._map.reqUpdateMapInfo(query, body);
    }

    public static async GetFeatureList(query: MapQueryParams, body: FeatureListReqBody): Promise<ResponseType> {
        return await this._map.reqFeatureList(query, body);
    }

    // Place
    public static async GetPlaceList(query: PlaceAllQueryParams, body?: ListSearchReqBody): Promise<ResponseType> {
        return await this._place.reqPlaceList(query, body);
    }

    public static async GetAllPlaceInfo(query: PlaceAllQueryParams, body: AllPlaceInfoReqBody): Promise<ResponseType> {
        return await this._place.reqAllPlaceInfo(query, body);
    }

    public static async GetPlaceInfo(query: PlaceInfoQueryParams): Promise<ResponseType> {
        return await this._place.reqPlaceInfo(query);
    }

    public static async UpdatePlaceViewCnt(query: PlaceQueryParams): Promise<ResponseType> {
        return await this._place.reqUpdateViewCnt(query);
    }

    public static async GetPlaceImageList(query: PlaceQueryParams, body?: ListSearchReqBody): Promise<ResponseType> {
        return await this._place.reqImageList(query, body);
    }
    // !@#!-OA1-M4-USE1>METHOD1-GM1. 장소 개수 조회 
    public static async GetPlaceCount(query: PlaceAllQueryParams): Promise<ResponseType> {
        return await this._place.reqPlaceCount(query);
    }

    public static async AddPlaceInfo(query: PlaceAllQueryParams, body: FormData) {
        return await this._place.reqAddPlaceInfo(query, body);
    }

    public static async UpdatePlaceInfo(query: PlaceQueryParams, body: FormData) {
        return await this._place.reqUpdatePlaceInfo(query, body);
    }

    public static async DeletePlaceInfo(query: PlaceQueryParams) {
        return await this._place.reqDeletePlaceInfo(query);
    }

    public static async AddPlaceImage(query: PlaceImageQueryParams, body: FormData) {
        return await this._image.reqAddPlaceImage(query, body);
    }

    public static async GetPlaceOwner(query: PlaceQueryParams): Promise<ResponseType> {
        return await this._place.reqPlaceOwner(query);
    }

    // story
    public static async GetStoryCount(query: StoryQueryParams): Promise<ResponseType> {
        return await this._story.reqStoryCount(query);
    }

    public static async GetStoryList(query: StoryQueryParams, body: StoryListReqBody): Promise<ResponseType> {
        return await this._story.reqStoryList(query, body);
    }

    public static async AddStory(query: StoryQueryParams, body: FormData): Promise<ResponseType> {
        return await this._story.reqAddStory(query, body);
    }

    public static async DeleteStory(query: StoryQueryParams): Promise<ResponseType> {
        return await this._story.reqDeleteStory(query);
    }

    public static async ReportStory(query: StoryQueryParams, body: StoryReportReqBody): Promise<ResponseType> {
        return await this._story.reqReportStory(query, body);
    }

    // request: kmap을 통하는 기능
    public static async ValidateAddress(body: AddressValidateReqBody): Promise<ResponseType> {
        return await this._request.reqAddressValidate(body);
    }

    public static async Geocoding(query: GeocodingQueryParams): Promise<ResponseType> {
        return await this._request.reqGeocoding(query);
    }

    public static async MultiFullGeocoding(body: MultiFullGeocodingReqBody): Promise<ResponseType> {
        return await this._request.reqMultiFullGeocoding(body);
    }

    public static async RevGeocoding(query: RevGeocodingQueryParams): Promise<ResponseType> {
        return await this._request.reqRevGeocoding(query);
    }

    // Map Analysis
    public static async GetRegionAnalysisData(query: RegionAnalysisQueryParams, data: RegionAnalysisReqBody): Promise<ResponseType> {
        return await this._analysis.reqRegionAnalysisData(query, data);
    }

    public static async GetAccessibilityData(data: AccessibilityReqBody): Promise<ResponseType> {
        return await this._analysis.reqAccessibilityData(data);
    }

    public static async GetIsochroneData(data: IsochroneReqBody): Promise<ResponseType> {
        return await this._analysis.reqIsochroneData(data);
    }

    public static async GetRouteData(data: RouteReqBody): Promise<ResponseType> {
        return await this._analysis.reqRouteData(data);
    }

    public static async GetSlopeData(data: SlopeReqBody): Promise<ResponseType> {
        return await this._analysis.reqSlopeData(data);
    }

    // Geojson Data
    public static async GetRegionPolygons(name: RegionType): Promise<ResponseType> {
        return await this._geojson.reqRegionData(name);
    }

    // Mailing
    public static async SendFindPassword(query: FindPasswordParams): Promise<ResponseType> {
        return await this._mail.reqSendFindPassword(query);
    }

    public static async SendFAQMail(query: FAQMailQueryParams): Promise<ResponseType> {
        return await this._mail.reqSendQuestion(query);
    }

    // FAQ
    public static async GetFAQType(): Promise<ResponseType> {
        return await this._faq.reqFAQType();
    }

    public static async GetFAQPopularList(query: FAQType): Promise<ResponseType> {
        return await this._faq.reqFAQPopularList(query);
    }

    public static async GetFAQPaging(query: FAQListQueryParams): Promise<ResponseType> {
        return await this._faq.reqFAQPaging(query);
    }

    public static async GetFAQList(query: FAQListQueryParams): Promise<ResponseType> {
        return await this._faq.reqFAQList(query);
    }

    public static async GetFAQView(query: FAQViewID): Promise<ResponseType> {
        return await this._faq.reqFAQView(query);
    }

    // AI
    public static async GetSummaryStream(body: SummaryReqBody, callback: SSEStreamCallback): Promise<void> {
        return await this._ai.reqSummaryStream(body, callback);
    }

    public static async GetSummary(body: SummaryReqBody): Promise<ResponseType> {
        return await this._ai.reqSummary(body);
    }
}
